import {ApiService} from "../api";
import {Skills} from "../../types";
import {AxiosResponse} from "axios";
import {SkillDTO} from "../../types/DTOs/SkillDTO";
import {SkillCategoryDTO} from "../../types/DTOs/SkillCategoryDTO";
import {Log} from "../../utils/Log";

export class SkillAPI extends ApiService {
    private constructor() {
        super();
    }

    async getSkills(): Promise<Skills[]> {
        const response: AxiosResponse<Skills[]> = await this.api.get('/skill');
        return response.data;
    }

    async getSkillCategories(language?: string): Promise<SkillCategoryDTO[]> {
        const params = language ? { language } : {};
        const response: AxiosResponse<SkillCategoryDTO[]> = await this.api.get('/skill/categories', { params });
        return response.data;
    }

    async createSkills(data: SkillDTO): Promise<Skills> {
        Log.writeLogDebug(data);
        const response: AxiosResponse<Skills> = await this.api.post('/skill', data);
        return response.data;
    }

    async updateSkills(id: string, data: Partial<SkillDTO>): Promise<Skills> {
        const response: AxiosResponse<Skills> = await this.api.put(`/skill/${id}`, data);
        return response.data;
    }

    async deleteSkills(id: string): Promise<void> {
        await this.api.delete(`/skill/${id}`);
    }
}